import React from 'react';
import './losing.css'
import Header from '../components/layout/header';
import pic11 from '../assets/pic11.png'
import pic48 from '../assets/pic48.png'
import Settings from '../components/common/settings';
import pic50 from '../assets/pic50.png'
import pic51 from '../assets/pic51.png'
import pic52 from '../assets/pic52.png'
import pic53 from '../assets/pic53.png'
import pic55 from '../assets/pic55.png'
import pic56 from '../assets/pic56.png'
import pic54 from '../assets/pic54.png'
import pic57 from '../assets/pic57.png'
import pic58 from '../assets/pic58.png'
import pic59 from '../assets/pic59.png'
import pic60 from '../assets/pic60.png'
import pic61 from '../assets/pic61.png'
import pic62 from '../assets/pic62.png'
import pic63 from '../assets/pic63.png'
import pic64 from '../assets/pic64.png'
import pic67 from '../assets/pic67.png'
import pic68 from '../assets/pic68.png'
import pic69 from '../assets/pic69.png'
import pic70 from '../assets/pic70.png'
import pic71 from '../assets/pic71.png'
import pic72 from '../assets/pic72.png'
import pic73 from '../assets/pic73.png'
import pic81 from '../assets/pic81.png'
import pic74 from '../assets/pic74.png'
import pic75 from '../assets/pic75.png'
import pic76 from '../assets/pic76.png'
import pic77 from '../assets/pic77.png'
import pic78 from '../assets/pic78.png'
import pic79 from '../assets/pic79.png'
import pic80 from '../assets/pic80.png'
import AudioContext from '../components/common/AudioContext';
import './howtoplayinstructions.css'
import Losingaudio from '../audio/Losing.mp4'
import './howtoplayinstructions.css'
import { useNavigate } from 'react-router-dom';
import pic96 from '../assets/pic96.png'
import pic97 from '../assets/pic97.png'
import pic98 from '../assets/pic98.png'
import pic99 from '../assets/pic99.png'
import CircleNav from '../components/common/circlenav';
import pic100 from '../assets/pic100.png'
import pic101 from '../assets/pic101.png'
import { useLocation } from 'react-router-dom';
import pic106 from '../assets/pic106.png'
import pic107 from '../assets/pic107.png'
import { useEffect } from 'react';
import { useState } from 'react';
import pic147 from '../assets/pic147.png'
import pic179 from '../assets/pic179.png'
import pic221 from '../assets/pic221.png'
import pic228 from '../assets/pic228.png'

import pic49 from '../assets/pic49.png';
import pic239 from '../assets/pic239.png';
import pic232 from '../assets/pic232.png';
import pic235 from '../assets/pic235.png';

const Losing = () => {
   const [settingsOpen, setSettingsOpen] = useState(false);
       const { soundVolume } = React.useContext(AudioContext);
    const audioRef = React.useRef(null);
    const [closing, setClosing] = useState(false);
     const navigate = useNavigate();
     const [nexting, setNexting] = useState(false);
     
    useEffect(() => {
            const audio = audioRef.current;
            if (!audio) return;
            audio.volume = soundVolume;
            audio.play().catch(() => {});

            return () => {
                audio.pause();
                audio.currentTime = 0;
            };
        }, []);

        useEffect(() => {
            if (audioRef.current) audioRef.current.volume = soundVolume;
        }, [soundVolume]);
  const location = useLocation();

  const score = location.state?.score || 0;
  const lives = location.state?.lives || 0;
  const collected = location.state?.collected || 0;
  const level = location.state?.level || 1;
  const levelBackgrounds = {
            1: pic49,
            2: pic239,
            3: pic232,
            4: pic235
        };

        const currentBackground = levelBackgrounds[level];


    const loseReason =
        location.state?.loseReason || 'obstacles';
     const selectedCharacter =
    localStorage.getItem('selectedCharacter') || 'Mohammed Tout';


        // const handleBack = () => {
        // setClosing(true);
        // setTimeout(() => navigate('/Story', { state: { back: true } }), 400);
        // };

        // const handleNext = () => {
        // setNexting(true); 
        // setTimeout(() => navigate('/Misson'), 400);
        // };

    return ( 
        <>
             {closing && <div className='story-bg-behind' />}
<main className={`level1--page ${closing ? 'slide-down' : ''}`}>
            <section className='levelbackground--page'>
                 <audio ref={audioRef} src={Losingaudio} preload="auto" />
                 {settingsOpen && <Settings onClose={() => setSettingsOpen(false)} />}
                <>

               <section className='settings-background'>
               <section  className={`howtoplay-overlay-inst ${nexting ? 'slide-down' : 'slide-up'}`}>
                <section className='header-losing-overlay'>
                    <div className='header-title-cont-settings'>
                        <h2 className='title-containerr-settings'>You Lose</h2>
                        <h2 className='title2-container-settings'>You Lose</h2>
                    </div>
                    
                </section>


                <section className='container-losing'>
               
                            <h2 className='title-losing'>  
                                {loseReason === 'obstacles'
                                ? <>You Hit <br /> Obstacles</>
                                : <>Artifacts  <br /> Missing</>}</h2>
                             <div className='stars-container-lose'>
                                
                                <img src={ pic96} alt='stars' />
                                <h3 className='score-lose'>{score}</h3>
         
                                <img src={ pic96} alt='stars' />

                                <img className='big-star-lose' src={pic97} alt='stars' />
                
                             </div>
                             <nav className='container-navs-losing'>
                                <CircleNav img2={pic98} icontext2='home'   onClick={() => navigate('/home')}/>
                              <CircleNav img2={pic99} icontext2='restart'  
                                 onClick={() =>
                                    navigate(
                                         level === 4
                                            ? '/level4start'
                                        :level === 3
                                            ? '/level3start'
                                        :level === 2
                                            ? '/level2start'
                                            : '/level1start'
                                    )
                                }/>                                
                             </nav>

                </section>

                </section>
                            <img className={`cloud ${nexting ? 'slide-down' : 'slide-up'}`} src={pic101} alt='cloud'></img>
            </section>
            <img 
            className={`character-crying ${nexting ? 'slide-down' : 'slide-up'}`}
            //  src={pic100}
            //  src={level === 2 ? pic147 : pic100}
                  src={
                    selectedCharacter === 'Ahmad Amon'
                    ? pic221
                   : selectedCharacter === 'Teyah Ramses'
                    ? pic179
                    : selectedCharacter === 'Mariam Lotus'
                    ?pic228
                    : selectedCharacter === 'Sarah Idress'
                        ? pic147
                         : pic100
                         }
              alt='character-crying'></img>

        </>
                    <div 
                        className='background-and-obstacles-lose'
                        style={{
                            '--level-bg': `url(${currentBackground})`
                        }}
                        >
                    <div className='container-obtsacles-and-collections'>
                        <img className='obstacle1' src={pic57} alt='obstacle-1'/>
                        <img className='obstacle2' src={pic58} alt='obstacle-2'/>
                        <img className='obstacle3' src={pic59} alt='obstacle-3'/>
                        <img className='obstacle4' src={pic60} alt='obstacle-4'/>
                        <img className='obstacle5' src={pic61} alt='obstacle-5'/>
                        <img className='collect1' src={pic62} alt='collect-1'/>  
                        <img className='obstacle6' src={pic63} alt='obstacle-6'/>  
                        <img className='obstacle7' src={pic64} alt='obstacle-7'/>   
                        <img className='obstacle8' src={pic67} alt='obstacle-8'/>                          
                        <img className='obstacle9' src={pic68} alt='obstacle-9'/>  
                        <img className='obstacle10' src={pic69} alt='obstacle-10'/>  
                        <img className='obstacle11' src={pic70} alt='obstacle-11'/>  
                        <img className='obstacle12' src={pic71} alt='obstacle-12'/>  
                        <img className='obstacle13' src={pic72} alt='obstacle-12'/> 
                        <img className='obstacle14' src={pic73} alt='obstacle-14'/> 
                        <img className='obstacle15' src={pic81} alt='obstacle-14'/> 
                        <img className='obstacle16' src={pic74} alt='obstacle-14'/> 
                        <img className='obstacle17' src={pic75} alt='obstacle-17'/> 
                        <img className='obstacle18' src={pic76} alt='obstacle-18'/> 
                        <img className='obstacle19' src={pic77} alt='obstacle-19'/>  
                        <img className='obstacle20' src={pic78} alt='obstacle-20'/>                            
                        <img className='obstacle21' src={pic79} alt='obstacle-20'/> 
                        <img className='obstacle22' src={pic80} alt='obstacle-20'/> 

                    </div>
                </div>

   
                <section className='container-hedaer-and-character-levels-page'>
                    <Header 
                    title='Level 1' title2='Level 1 '
                    link='/home'  onClick={() => setSettingsOpen(true)}
                    img={pic48} icontext='pause icon'
                    img2={pic11} icontext2='settings icon'/>
                 <img className='character-movement' src={pic54} alt='character'></img>




                    <div className='HUD-container'>

                            <div className='lives-frame-Hud'>
                                <div className='lives-container-HUD'>
                                    <img className='decoration2-HUD' src={pic56} alt='decoration-HUD'></img>
                                    <div className='hearts-container'>
                                        <img src={pic53} alt='heart'></img>
                                        <img src={pic53} alt='heart'></img>
                                        <img src={pic53} alt='heart'></img>
                                    </div>
                                </div>
                            </div>

                        <div className='frame-Hud'>
                            <div className='HUD-1-container'>

                                <img className='decoration-HUD' src={pic55} alt='decoration-HUD'></img>

                                <h2 className='collect-text'>Collect:</h2>
                                <div className='row-pic-HUD'>
                                    <div className='img-container-HUD'> 
                                        <img src={pic50} alt='collect-item-1'></img>
                                    </div>

                                    <div className='img-container-HUD'> 
                                        <img src={pic51} alt='collect-item-1'></img>
                                    </div>


                                    <div className='img-container-HUD'> 
                                        <img src={pic52} alt='collect-item-1'></img>
                                    </div>

                                </div>
                            </div>


                        </div>
                    </div>



                </section>
            </section>
          </main>

         </>
     );
}
 
 
export default Losing;